// import React from 'react';
// import ReactDOM from 'react-dom';
// import {
//     BrowserRouter,
//     Route,
//     Switch
// } from 'react-router-dom';
// import { Provider } from "react-redux";
// import indexRoutes from './routes/index.jsx';

// import registerServiceWorker from './registerServiceWorker';

// import './assets/css/bootstrap.min.css';
// import './assets/sass/light-bootstrap-dashboard.css';
// import './assets/css/demo.css';
// import './assets/css/pe-icon-7-stroke.css';

// import { configureStore } from "./store";

// const appStore = configureStore();

// ReactDOM.render((
//     <Provider store={appStore}>
//         <BrowserRouter>
//             <Switch>
//                 {
//                     indexRoutes.map((prop, key) => {
//                         return (
//                             <Route path={prop.path} component={prop.component} key={key} />
//                         );
//                     })
//                 }
//             </Switch>
//         </BrowserRouter>
//     </Provider>
// ), document.getElementById('root'));
// registerServiceWorker();


import * as React from "react";
import { render } from "react-dom";
import { configureStore } from "./store";
import { Provider } from "react-redux";
import registerServiceWorker from './registerServiceWorker';

import indexRoutes from './routes/index.jsx';

import { BrowserRouter, Route, Switch } from "react-router-dom";


import './assets/css/bootstrap.min.css';
import './assets/sass/light-bootstrap-dashboard.css';
import './assets/css/demo.css';
import './assets/css/pe-icon-7-stroke.css';
import 'react-tippy/dist/tippy.css';

const appStore = configureStore();

render(
    <div>
        <Provider store={appStore}>
            <BrowserRouter>
                <Switch>
                    {
                        indexRoutes.map((prop, key) => {
                            return (
                                <Route path={prop.path} component={prop.component} key={key} />
                            );
                        })
                    }
                </Switch>
            </BrowserRouter>
        </Provider>
    </div>,
    document.getElementById("root")
);
registerServiceWorker();




// WEBPACK FOOTER //
// ./src/index.js